import Roof from './roof.js'
let text = window.text; // We depend on global localization

// Wrapper of Roof.angle to account for whole width being used
let angle = function(height, width){
  return Roof.angle(height,width*2.0);
}

// Wrapper of Roof.angle to account for whole width being used
let angleToHeight = function(width, angle){
  return Roof.angleToHeight(width*2.0, angle);
}

export default class TiltedRoof extends Roof {

  constructor(r,p) {
    super(r,p)

    this.inputs = [
      {
        name: "length",
        title: text.length
      },
      {
        name: "width",
        title: text.width
      },
      {
        name: "height",
        title: text.height,
        alternatives:{
          names: ["angle"],
          convertTo: function(propertyName, height, values){
            if (propertyName == "height"){
              return height;
            }
            return angle(height,values["width"])*Roof.radianToDegree();
          },
          convertFrom: function(propertyName, propertyValue, values){
            if (propertyName == "height"){
              return propertyValue;
            }
            let angle = propertyValue*Roof.degreeToRadian();
            return angleToHeight(values["width"], angle);
          },
        },
      },
    ]

    this.name = text.rTilted
    this.description = text.rdTilted
  }

	pipes() {
		let i = this.props
		return [i.length]
  }
  
  vindski() {
    return 2 * this.props.width/Math.cos(angle(this.props.height, this.props.width));
  }

  mone() {
    return 0.0;
  }

  topatches() {
    let patches = [
      this.fromrect(
        1000*this.props.length,
        1000*this.props.width/Math.cos(angle(this.props.height, this.props.width)),
      ),
    ];
    return patches
  }

  patchtransforms() {
    let off = (this.props.length + this.props.width) / 20
    return [
      {
        t: [0,0],
        r: [0, 0, 0],
      }
    ]
  }

  validateInput(inputs){
    return undefined;
  }

}



// WEBPACK FOOTER //
// ./roofs/tiltedroof.js